export const handleComplexLayoutCarousel = () => {
  const slidesList = document.querySelectorAll('.carousel-items-list li');
  const imagesList = document.querySelectorAll('.carousel-image-grid');
  const textList = document.querySelectorAll('.carousel-items-text .item-text');

  const setActiveSlide = (el) => {
    const slideIndex = parseInt(el.target.getAttribute('data-slide'));

    slidesList.forEach((item, index) => {
      item.classList.toggle('active', index === slideIndex - 1);
    });

    handleActiveImage(slideIndex);
    handleActiveText(slideIndex);
  };

  const handleActiveImage = (slideNum) => {
    imagesList.forEach((item, index) => {
      item.classList.toggle('active', index === slideNum - 1);
    });
  };

  const handleActiveText = (slideNum) => {
    textList.forEach((item, index) => {
      item.classList.toggle('active', index === slideNum - 1);
    });
  };

  slidesList.forEach((item) => {
    item.addEventListener('click', setActiveSlide);
  });

  const init = () => {
    imagesList.forEach((image) => {
      if (image.childElementCount === 3) {
        image.classList.add('three-item-layout');
      } else if (image.childElementCount === 2) {
        image.classList.add('two-item-layout');
      } else if (image.childElementCount === 1) {
        image.classList.add('one-item-layout');
      }
    });
  }

  init();
};



// WEBPACK FOOTER //
// ./src/templates/components/complex-layout-carousel/complex-layout-carousel.js